import React, { useCallback } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

import { get, useApplicationState, usePreferences } from '@atlas/core';
import { FavoriteButton, Icon } from '@atlas/ui';

const MarketTypeHeader = ({
  betGroups,
  expandedMarketTypes,
  isExpanded,
  isFavorite,
  marketTypeId,
  name,
  setExpandedMarketTypes,
}) => {
  const { selectFavoriteMarketType } = usePreferences();
  const applicationState = useApplicationState();
  const authenticated = get(applicationState, 'authenticated');

  const selectFavoriteMarketTypeHandler = useCallback(
    event => {
      event.stopPropagation();

      selectFavoriteMarketType({ marketTypeId });
    },
    [marketTypeId, selectFavoriteMarketType],
  );

  const toggleExpand = useCallback(() => {
    const newExpandedMarketTypes = {
      ...expandedMarketTypes,
      [marketTypeId]: !isExpanded,
    };

    setExpandedMarketTypes(newExpandedMarketTypes);
  }, [expandedMarketTypes, setExpandedMarketTypes, isExpanded, marketTypeId]);

  const arrowClassName = cx({
    down: !isExpanded,
    up: isExpanded,
  });

  return (
    <div
      className="menu-item-container sport"
      data-test-item-expanded={isExpanded}
      data-test-item-id={marketTypeId}
      data-testid="event-details-market-type"
      onClick={toggleExpand}
    >
      {authenticated && selectFavoriteMarketType && (
        <div className="menu-item-icon">
          <FavoriteButton active={isFavorite} onClick={selectFavoriteMarketTypeHandler} />
        </div>
      )}

      <div className="menu-item-text">
        <h2 className="main-label">{name}</h2>
      </div>
      <div className="menu-item-icon-controls">
        <div className="font-icon-container related-market">
          <Icon className="icon-link" name="link" />
          <span className="title-small-text">{Object.values(betGroups).join(', ')}</span>
        </div>
        <span className="icon-cashout" />
        <div className="font-icon-container">
          <Icon className={`icon-arrow-${arrowClassName}`} name={`arrow-${arrowClassName}`} />
        </div>
      </div>
    </div>
  );
};

MarketTypeHeader.propTypes = {
  betGroups: PropTypes.array.isRequired,
  expandedMarketTypes: PropTypes.objectOf(PropTypes.bool),
  isExpanded: PropTypes.bool.isRequired,
  isFavorite: PropTypes.bool.isRequired,
  marketTypeId: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  setExpandedMarketTypes: PropTypes.func,
};

export default MarketTypeHeader;
